import React from 'react';
import hero_image from '../../../assets/images/courses/banner_detail.png';
const HeroSection = () => {
  return (
    <section
      className="home-hero-banner position-relative overflow-hidden mb-md-0 mb-5"
      style={{ backgroundImage: `url(${hero_image})` }}
    ></section>
  );
};

export default HeroSection;
